export type OfflineMutationLike = {
  id?: number;
  method: string;
  url: string;
  body?: unknown;
};

const SENSITIVE_KEYS = new Set([
  'authorization',
  'apikey',
  'apitoken',
  'xapikey',
  'clientsecret',
  'refreshtoken',
  'smtpkey',
  'webhooksecret',
  'secretaccesskey',
  'pass',
  'password',
  'ioniteapikey',
  'storecoveapikey',
]);

const normalizeKey = (key: string) => key.toLowerCase().replace(/[^a-z0-9]/g, '');

const hasSensitiveKey = (value: unknown): boolean => {
  if (value === null || typeof value !== 'object') {
    return false;
  }

  if (Array.isArray(value)) {
    return value.some(hasSensitiveKey);
  }

  return Object.entries(value as Record<string, unknown>).some(([key, nestedValue]) => {
    return SENSITIVE_KEYS.has(normalizeKey(key)) || hasSensitiveKey(nestedValue);
  });
};

export const isSensitiveOfflineMutation = (_url: string, body: unknown) => {
  return hasSensitiveKey(body);
};

export const offlineMutationMetadata = (mutation: OfflineMutationLike) => {
  return {
    ...(mutation.id !== undefined ? { id: mutation.id } : {}),
    method: mutation.method,
    url: mutation.url,
  };
};
